var map = {
	"./404-image.svg": 43581,
	"./Menu_Arrow.svg": 26408,
	"./ReferAFriend.png": 4772,
	"./Sign_Up_Banner.svg": 63973,
	"./Tick.png": 89564,
	"./VerifyOtp.png": 19061,
	"./Z_Small.svg": 6187,
	"./Zlogo.svg": 79114,
	"./ZyNerd-Final-Logo-Dark-BG.jpg": 17339,
	"./ZyNerd-Final-Logo-Dark-BG.webp": 84451,
	"./ZyNerd-Final-Logo-Icon-only.png": 52301,
	"./ZyNerd-Final-Logo.webp": 98486,
	"./Zynerd_logo_blue.svg": 52824,
	"./aiimslogo.png": 13609,
	"./allotmentMappingScreenshot.png": 20809,
	"./allotmentsScreenshot.png": 82256,
	"./amazonpay.png": 80693,
	"./app-store-badge.png": 16496,
	"./authlayoutbg.png": 94946,
	"./bannerPattern.png": 62247,
	"./bhim.svg": 26683,
	"./choiceListScreenshot.png": 36998,
	"./closingRanksScreenshot.png": 29769,
	"./cone.svg": 64722,
	"./cred_circle.png": 71584,
	"./doctor1.png": 18001,
	"./doctor2.png": 87834,
	"./doctor3.png": 5411,
	"./doctor4.png": 75244,
	"./doctor5.png": 44341,
	"./doctor6.png": 76990,
	"./doctor7.png": 95303,
	"./doctor8.png": 51072,
	"./doctor9.png": 5897,
	"./empty_box.png": 12854,
	"./exclusivebg.svg": 90912,
	"./exclusivebg2.svg": 6322,
	"./feature_1.png": 80561,
	"./feature_2.png": 55898,
	"./feature_3.png": 77475,
	"./feeStipendBondScreenshot.png": 99213,
	"./feedback-thank-you.webp": 21169,
	"./feedback-welcome.png": 6133,
	"./google-play-badge.png": 97241,
	"./googlepay.svg": 71516,
	"./insights.png": 25396,
	"./mobile-app.png": 37039,
	"./newlogo.svg": 35462,
	"./no-videos-found.webp": 6388,
	"./noimage.png": 78863,
	"./noimg1.png": 15540,
	"./non-subscriber.png": 49655,
	"./notificationIcon.svg": 43773,
	"./pageNotFound.svg": 93059,
	"./paytm.svg": 60150,
	"./phonepe.svg": 34116,
	"./postban.svg": 93456,
	"./postsubimg.png": 38558,
	"./predictorVideo.jpeg": 73583,
	"./presubscription_bg.png": 44321,
	"./primary-video.png": 98299,
	"./privatevideodoodle.gif": 84609,
	"./quriesMail.png": 58239,
	"./quriesPattern.png": 69034,
	"./quriesSupport.png": 96121,
	"./rankScanScreenshot.png": 22526,
	"./referWinBanner.svg": 28221,
	"./referralBanner.png": 49442,
	"./referralBanner.svg": 98118,
	"./referralBannerMob.svg": 62324,
	"./referralWinMobile.svg": 23900,
	"./resourcesAndTools.png": 89528,
	"./seatMatrixScreenshot.png": 28319,
	"./success.gif": 32121,
	"./supportAndCommunity.png": 50540,
	"./transfergif.gif": 37089,
	"./unsubscribed_Offers.png": 45218,
	"./upgrade_Offers.png": 62393,
	"./upiTransactionFail.png": 18931,
	"./upiTransactionSuccess.png": 94326,
	"./upiTransactionTimeout.webp": 9824,
	"./video_1.png": 88478,
	"./video_2.png": 55829,
	"./video_3.png": 86732,
	"./videobanner.png": 15308,
	"./videoplayer.jpg": 39661,
	"./videothumb.png": 38424,
	"./youtubeThumbnail.png": 53762,
	"./zy_logo.svg": 74590,
	"./zytalesLogoText.webp": 83881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;